import useResponsive from './useResponsive';

export default function useChartSettings(data?: any[]) {
  const isMobile = useResponsive('down', 'sm');

  const base_colors = ['#2F795E', '#7DB25C', '#F6E052', '#FFAC5B', '#FF7F81', '#E46AA8', '#0076FF'];
  const margin = isMobile ? { bottom: 30, left: 30, right: 30, top: 30 } : { top: 30, bottom: 30 };

  const position = isMobile
    ? { vertical: 'bottom' as const, horizontal: 'middle' as const }
    : { vertical: 'middle' as const, horizontal: 'right' as const } as any;

  const direction = isMobile ? 'horizontal' as const : 'vertical' as const;

  const pieChartSetting = {
    height: 260,
    colors: base_colors,
    margin: margin,
    slotProps: {
      tooltip: { trigger: 'item' as const },
      legend: {
        direction: direction,
        position: position,
        mark: {
          labelMarkType: 'square',
        }
      },
    },
  };

  const barChartSettings = {
    colors: ['#2F795E'],
    height: 220,
    margin: { right: 130, left: 0, top: 0, bottom: 0 },
    hideLegend: true,
  };

  const doubleChartSettings = {
    height: 200,
    colors: base_colors,
    margin: { left: 0, right: 0, top: 0, bottom: 0 },
  };

  return {
    pieChartSetting,
    barChartSettings,
    doubleChartSettings,
  };
}
